import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Divider, Switch, TextInput } from '@mantine/core';
import ResponsiveModal from '../../common/ResponsiveModal';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';
import AppFlexbox from '../../common/AppFlexbox';
import PaginationList from '../../common/PaginationList';

const TreasurerEmailSelectModal = ({
  isOpen,
  onClose,
  onConfirm,
  resource,
  admins
}) => {
  const [formState, setFormState] = useState({
    treasurerEmailDisabled: true,
    treasurerAlertsEmail: ''
  });

  useEffect(() => {
    if (isOpen) {
      setFormState({
        treasurerEmailDisabled: resource?.treasurerEmailDisabled ?? false,
        treasurerAlertsEmail: resource?.treasurerAlertsEmail ?? ''
      });
    }
  }, [isOpen]);

  return (
    <ResponsiveModal
      formSectionProps={{
        submitTitle: 'Done',
        onCancel: onClose,
        onSubmit: () => {
          onConfirm(formState);
        }
      }}
      isNewModalStyle
      isOpen={isOpen}
      onClose={onClose}
      title="Treasurer email"
    >
      <AppStack style={{ gap: 20 }}>
        <AppStack style={{ gap: 5 }}>
          <AppText style={{ fontSize: 14, fontWeight: 500 }}>
            Enable treasurer email
          </AppText>

          <AppFlexbox>
            <Switch
              checked={!formState.treasurerEmailDisabled}
              onChange={() => {
                setFormState({
                  ...formState,
                  treasurerEmailDisabled: !formState.treasurerEmailDisabled
                });
              }}
              size="lg"
              styles={{ track: { cursor: 'pointer' } }}
            />
          </AppFlexbox>
        </AppStack>

        <Divider />

        {formState.treasurerEmailDisabled ? (
          !admins ? (
            <AppStack style={{ gap: 12 }}>
              <AppText
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: '#C40000',
                  textAlign: 'center'
                }}
              >
                No transaction notifications will be sent.
              </AppText>
            </AppStack>
          ) : (
            <AppStack style={{ gap: 12 }}>
              <AppText
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: '#C40000',
                  textAlign: 'center'
                }}
              >
                Treasurer email disabled.
              </AppText>
              <AppText
                style={{
                  fontSize: 14,
                  color: '#666',
                  fontStyle: 'italic',
                  textAlign: 'center'
                }}
              >
                The following admins will receive all transaction notifications.
              </AppText>

              <PaginationList
                emptyMessage="No store admins have been assigned yet."
                items={
                  admins
                    ?.filter((a) => !a.deleted)
                    .map((admin) => (
                      <AppFlexbox
                        key={admin.pkEcomStoreAdmin || admin.pkEcomVendorAdmin}
                        style={{ padding: 8 }}
                      >
                        <AppStack style={{ gap: 0 }}>
                          <AppText style={{ fontSize: 14, fontWeight: 500 }}>
                            {admin.user.name}
                          </AppText>
                          <AppText style={{ fontSize: 14, color: '#666' }}>
                            {admin.user.email}
                          </AppText>
                        </AppStack>
                      </AppFlexbox>
                    )) || []
                }
                itemsPerPage={10}
              />
            </AppStack>
          )
        ) : (
          <AppStack style={{ gap: 12 }}>
            <AppText
              style={{
                fontSize: 14,
                color: '#666',
                fontStyle: 'italic',
                textAlign: 'center'
              }}
            >
              All store transaction notifications will be sent to the email
              address below.
            </AppText>

            <TextInput
              label="Email address"
              onChange={(e) =>
                setFormState({
                  ...formState,
                  treasurerAlertsEmail: e.currentTarget.value
                })
              }
              placeholder="email@domain.com"
              required
              type="email"
              value={formState.treasurerAlertsEmail}
            />
          </AppStack>
        )}
      </AppStack>
    </ResponsiveModal>
  );
};

TreasurerEmailSelectModal.propTypes = {
  admins: PropTypes.array,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  resource: PropTypes.object
};

export default TreasurerEmailSelectModal;
